import { render } from "./CenterPopup.vue?vue&type=template&id=10989384&scoped=true"
import script from "./CenterPopup.vue?vue&type=script&lang=js"
export * from "./CenterPopup.vue?vue&type=script&lang=js"

import "./CenterPopup.vue?vue&type=style&index=0&id=10989384&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10989384"]])

export default __exports__